<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-29 20:09:36
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-13 15:50:21
-->
<template>
  <JobQueryList :orderCategory="3" />
</template>

<script>
import JobQueryList from "@/components/JobQuery/List";
export default {
  name: "JobQuery",
  data() {
    return {};
  },
  components: { JobQueryList },
  filters: {},
  watch: {},
  mounted() {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
